/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDocumentCommand
 */
export interface UpdateDocumentCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentCommand
     */
    mediaCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentCommand
     */
    fileUploadId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentCommand
     */
    remoteFileUrl?: string | null;
}

export function UpdateDocumentCommandFromJSON(json: any): UpdateDocumentCommand {
    return {
        'mediaCategoryId': json['mediaCategoryId'],
        'name': json['name'],
        'fileUploadId': !exists(json, 'fileUploadId') ? undefined : json['fileUploadId'],
        'remoteFileUrl': !exists(json, 'remoteFileUrl') ? undefined : json['remoteFileUrl'],
    };
}

export function UpdateDocumentCommandToJSON(value?: UpdateDocumentCommand | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'mediaCategoryId': value.mediaCategoryId,
        'name': value.name,
        'fileUploadId': value.fileUploadId,
        'remoteFileUrl': value.remoteFileUrl,
    };
}


